export default {
    methods: {
        can(privilege) {
            const userData = JSON.parse(localStorage.getItem('userData'))
            const currentUserPrivilege = userData.courtier_user.length > 0 ? userData.courtier_user[0].privilege : []
            const isExist = currentUserPrivilege.findIndex(el => el.label === privilege)
            return isExist > -1
        },
        isPrincipal() {
            const currentUser = JSON.parse(localStorage.getItem('userData'))
            // eslint-disable-next-line no-nested-ternary
            return currentUser.courtier_user.length > 0 ? currentUser.courtier_user[0].isPrincipal == 1 ? true : false : false
        },
        hasPermission(groupe) {

            switch (groupe) {
                case 'register':
                    return true
                case 'auth-login':
                    return true
                case 'home-page':
                    return true
                case 'messageries':
                    return true
                case 'messageries-folder':
                    return true
                case 'messageries-label':
                    return true
                case 'page-not-authorized':
                    return true
                case 'conformite-list':
                    if (this.can('Add compliance')
                        || this.can('List compliances')
                        || this.can('Visualize document compliance')
                        || this.can('Historize compliance') ||
                        this.isPrincipal()
                    )
                        return true
                    return false
                case 'contrats-list':
                    if (this.can('Import contract')
                        || this.can('Update contract')
                        || this.can('Delete contract')
                        || this.can('Add document to contract')
                        || this.can('List contracts of broker')
                        || this.can('List contracts by commercial')
                        || this.can('Export Contracts'))
                        return true
                    return false
                case 'calendrier':
                    return true
                case 'gestion-interlocuteurs':
                    if (this.can("Create user")
                        || this.can("Update user")
                        || this.can("List users")
                        || this.can("Add training user")
                        || this.can("Update training user")
                        || this.can("Delete training user")
                        || this.can("Visualize training user")
                        || this.can("List trainings user")
                        || this.can("management permissions user")
                        || this.can("Add document user")
                        || this.can("Delete document user")
                        || this.can("Visualize document user")
                        || this.can("List documents user"))
                        return true
                    return false
                case 'gestion-cabinet':
                    if (this.can("Update logo")
                        || this.can("Update broker informations")
                        || this.can("Show details broker")
                        || this.can("Update informations legal broker")
                        || this.can("List of insured codes")
                        || this.can("Add other documents")
                        || this.can("List other documents")
                        || this.can("Visualize other documents")
                        || this.can("Delete other documents")
                        || this.can("Signature protocole")
                        || this.can("List notes")
                        || this.can("Create note"))
                        return true
                    return false
                case 'tiers-list':
                    if (this.can("Create client")
                        || this.can("Update client")
                        || this.can("Pricing a customer")
                        || this.can("Show detail client")
                        || this.can("List clients of broker")
                        || this.can("List clients by commercial")
                        || this.can("Affect client to commercial")
                        || this.can("Export Clients"))
                        return true
                    return false

                case 'projets-list':
                    if (this.can("Import project")
                        || this.can("Update project extern")
                        || this.can("Add document to project")
                        || this.can("Create client with project")
                        || this.can("Subscribe pricing")
                        || this.can("Update project intern")
                        || this.can("List projects of broker")
                        || this.can("List projects by commercial")
                        || this.can("Export Projects")
                    )
                        return true
                    return false
                case 'projets-proposition':
                    if (this.can("Update project intern"))
                        return true
                    return false
                case 'projets-souscription':
                    if (this.can("Update project intern"))
                        return true
                    return false
                case 'bibliotheque-mails':
                    if (this.can("Create modele")
                        || this.can("Visualize modele")
                        || this.can("Update modele")
                        || this.can("Delete modele")
                        || this.can("List modeles"))
                        return true
                    return false
                case 'commissions-list':
                    if (this.can('Add document to bordereau')
                        || this.can('Show bordereau details')
                        || this.can('Create Bordereau')
                        || this.can('List bordereaux')
                        || this.can('Modify bordereau')
                        || this.isPrincipal()
                    )
                        return true
                    else
                        return false
                case 'guide':
                    return true
                // case 'annuaire':
                //     return true
                case 'webinars':
                    return true
                case 'mon-contact':
                    return true
                case 'faqs-lists':
                    return true
                case 'back-office-courtiers':
                    return true
                case 'back-office-assureurs':
                    return true
                case 'back-office-extraction':
                    return true
                case 'back-office-statistiques-sessions':
                    return true
                case 'back-office-risque':
                    if (JSON.parse(localStorage.getItem('userData')).courtier_user[0].user_id == 5)
                        return true
                    return false
                case 'back-office-guide':
                    if (JSON.parse(localStorage.getItem('userData')).courtier_user[0].user_id == 5)
                        return true
                    return false
                case 'back-office-carousels':
                    return true
                case 'back-office-gestion':
                    return true
                case 'back-office-webinars':
                    return true
                case 'back-office-getstion-bordereauBBI':
                    return true
                case 'catalogues-list':
                    if (JSON.parse(localStorage.getItem('userData')).assureur_user != null && JSON.parse(localStorage.getItem('userData')).type_utilisateur == 'assureur' && JSON.parse(localStorage.getItem('userData')).assureur_user) {
                        return false;
                    }
                    return true
                case 'assureur-profile':
                    if (JSON.parse(localStorage.getItem('userData')).assureur_user != null && JSON.parse(localStorage.getItem('userData')).type_utilisateur == 'assureur' && JSON.parse(localStorage.getItem('userData')).assureur_user) {
                        return true;
                    }
                    return false
                case 'produits-list':
                    if (JSON.parse(localStorage.getItem('userData')).assureur_user != null && JSON.parse(localStorage.getItem('userData')).type_utilisateur == 'assureur' && JSON.parse(localStorage.getItem('userData')).assureur_user) {
                        return true;
                    }
                    return false
                case 'universign-transaction':
                    return true
                case 'universign-mandat':
                    return true
                case 'mandat-sepa':
                    return true
                case 'congratulation':
                    return true
                case 'cancelsignature':
                    return true
                case 'reclamations-list':
                    if (this.can("Show complaints")
                        || this.isPrincipal()
                    )
                        return true
                    else
                        return false;
                case 'sinistres-list':
                    if (this.can("Show claims")
                        || this.isPrincipal()
                    )
                        return true
                    else
                        return false;
                case 'projets-notifier':
                    return true
                case 'gda-list':
                    if (this.can('Show GDA') || this.isPrincipal())
                        return true
                    else return false
                case 'bordereaux-details':
                    return true
                case 'projets-solliciter':
                    return true
                case 'fiche-demande-ouverture-code':
                    return true
                case 'beneficier-un-pack-de-formation-dda':
                    return true
                case 'quickwins-tarification':
                    if (JSON.parse(localStorage.getItem('userData')).assureur_user != null && JSON.parse(localStorage.getItem('userData')).type_utilisateur == 'assureur' && JSON.parse(localStorage.getItem('userData')).assureur_user) {
                        return false;
                    }
                    return true
                case 'webinars':
                    return true
                case 'conformite-guide':
                    return true
                case undefined:
                    return true
                default:
                    return false
            }
        }
    }
}